/**
 * Generic single-sign-on badge: a keyhole inside a shield.
 *
 * Extra SVG props are forwarded so callers that render it as a stand-in for a
 * specific provider's mark can tag it the same way ({@link OidcProviderIcon}).
 */
export function OidcIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M12 2.5 4.5 5.4v6.1c0 4.6 3.2 8.4 7.5 9.9 4.3-1.5 7.5-5.3 7.5-9.9V5.4L12 2.5Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="10.2" r="2.1" fill="currentColor" />
      <path d="M12 12.1v3.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
